import React from 'react';

export default function TopBar() {
  return (
    <div className="w-full bg-[#0f172a] text-white text-[12px] tracking-wide">
      <div className="max-w-[1400px] mx-auto px-4 py-2 flex items-center justify-between">
        <div className="hidden md:flex items-center gap-6">
          <span className="flex items-center gap-1.5 opacity-90"><i className="ri-truck-line"></i> Free shipping above ₹999</span>
          <span className="flex items-center gap-1.5 opacity-90"><i className="ri-refresh-line"></i> 15-Day Returns</span>
        </div>
        <div className="flex-1 md:flex-none overflow-hidden">
          <div className="whitespace-nowrap animate-marquee flex gap-12">
            <span>FLAT 50% OFF ON FIRST ORDER • USE CODE: TREND50</span>
            <span>FLAT 50% OFF ON FIRST ORDER • USE CODE: TREND50</span>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-4">
          <a href="#" className="hover:underline">Download App</a>
          <a href="#" className="hover:underline">Track Order</a>
        </div>
      </div>
    </div>
  );
}